// @flow ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormBackSide component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observe } from 'mobx';
import { get, uniqueId } from 'lodash/fp';

import { Tabs, Tab } from 'share/components/controls/Izenda.Tab';
import constants from 'logic/data/Izenda.ReportPartFormConstants';

import ReportPartFormVisual from './Izenda.ReportPartFormVisual';
import ReportPartFormDnD from './Izenda.ReportPartFormDnD';
const ReportPartFormHTML = ReportPartFormDnD(require('./Izenda.ReportPartFormHTML'));

@observer
export default class ReportPartFormBackSide extends Component {
  static propTypes = {
    reportPart: PropTypes.object
  };

  init(activeKey: any) {
    const {
      props: {
        reportPart: { reportPartContent },
        store
      }
    } = this;
    reportPartContent.setFormState(activeKey || constants.TAB_VISUAL.key, uniqueId('reportPartForm-'));
    // get data tree to support populate field info from html
    reportPartContent.setDataTree(store.model.dataTree);
    reportPartContent.syncFromHTMLToElements();
  }

  constructor(props) {
    super(props);
    this.init();
    // for case when update result populate old report part object but create new
    // report part content object, need to repopulate data for this new object
    this.disposeObserve = observe(this.props.reportPart, 'reportPartContent', (newObj, oldObj) => {
      this.init(get('activeTabKey', oldObj));
    });
  }

  componentWillUnmount() {
    this.disposeObserve();
  }

  setSelectedTab = (index: number, tabPanel: any, tab: any, activeTabKey: string): any => {
    const {
      props: { reportPart }
    } = this;

    // Update form definition with new information from html content.
    if (reportPart.reportPartContent.activeTabKey === constants.TAB_HTML.key) {
      reportPart.reportPartContent.syncFromHTMLToElements();
    }
    reportPart.reportPartContent.activeTabKey = activeTabKey;
  };

  // hack for case sync, will fix on tabs when add promise resolve for before on change.
  beforeChangeTab = (index: number, tabPanel: any, tab: any, activeTabKey: string): any => {
    const {
      props: { reportPart }
    } = this;

    // Update form definition with new information from html content.
    if (reportPart.reportPartContent.activeTabKey === constants.TAB_HTML.key) {
      return Promise.resolve(true);
    } else {
      return reportPart.reportPartContent.rebuildHTMLContent(true);
    }
  };

  render() {
    const {
      props,
      props: { reportPart }
    } = this;
    const visualTab = constants.TAB_VISUAL;
    const htmlTab = constants.TAB_HTML;

    return (
      <Tabs
        canChangeTab={this.beforeChangeTab}
        className="report-part-form full-height u-bgGray"
        activeTabKey={reportPart.reportPartContent.activeTabKey}
        onChange={this.setSelectedTab}
      >
        <Tab title={visualTab.value} tabKey={visualTab.key}>
          <ReportPartFormVisual {...props} />
        </Tab>
        <Tab title={htmlTab.value} tabKey={htmlTab.key}>
          <ReportPartFormHTML {...props} />
        </Tab>
      </Tabs>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFormBackSide.js